import { jwtDecode } from 'jwt-decode';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { subscribeEvents } from '../constants';
export const AuthContext = createContext(undefined);
const getUserLogin = (token)=>token?.token_details?.originalUserLogin;
export const useAuthClient = ()=>useContext(AuthContext);
export const useDecodedToken = ()=>{
    const [decodedToken, setDecodedToken] = useState(null);
    const authClient = useAuthClient();
    useEffect(()=>{
        (async ()=>{
            if (authClient) {
                const token = await authClient.getAccessToken();
                if (token) {
                    setDecodedToken(jwtDecode(token));
                }
            }
        })();
    }, [
        authClient
    ]);
    return decodedToken;
};
export const useFreshAccessToken = ()=>{
    const [accessToken, setAccessToken] = useState(undefined);
    const authClient = useAuthClient();
    useEffect(()=>{
        let timeoutId = undefined;
        const unsubscribe = authClient?.on(subscribeEvents.token, (newToken)=>{
            if (newToken !== accessToken) {
                setAccessToken(newToken);
            }
        });
        const getToken = async ()=>{
            if (authClient) {
                const token = await authClient.getAccessToken();
                if (token) {
                    setAccessToken(token);
                    const expiresAt = authClient.getExpiresAt();
                    const delay = Math.max((expiresAt - 2) * 1000, 0);
                    timeoutId = setTimeout(getToken, delay);
                }
            }
        };
        getToken();
        return ()=>{
            unsubscribe?.();
            clearTimeout(timeoutId);
        };
    }, [
        authClient,
        accessToken
    ]);
    return [
        accessToken ? jwtDecode(accessToken) : undefined,
        accessToken
    ];
};
export const useUserLogin = ()=>{
    const decodedToken = useDecodedToken();
    return getUserLogin(decodedToken);
};
export const useLazyUserLogin = ()=>{
    const authClient = useAuthClient();
    return useCallback(()=>getUserLogin(authClient?.getDecodedAccessTokenFromCache()), [
        authClient
    ]);
};
